import React, { memo } from 'react'
import { capitalize } from 'lodash'
import PropTypes from 'prop-types'

const ErrorMessage = (props) => {
  const {
    className, id, style, message, children
  } = props

  return (
    <p id={id} className={className} style={{ ...style }}>
      {children}
      {capitalize(message)}
    </p>
  )
}

ErrorMessage.defaultProps = {
  className: 'color-red',
  id: '',
  style: {},
  message: '',
  children: null
}

ErrorMessage.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string,
  style: PropTypes.objectOf(PropTypes.any),
  message: PropTypes.string,
  children: PropTypes.objectOf(PropTypes.any)
}

export default memo(ErrorMessage)
